export const defaultState = () => ({
    boards: [],
    selectedBoard: null
});

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    // @TODO save in store
    index() {
        return this.$axios.$get('/boards');
    },

    show(ctx, slug) {
        return this.$axios.$get(`/boards/${slug}`);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
